<template>
  <div class="qx-empty-data h-100 d-flex justify-center align-center">
    <div class="empty-block text-center">
      <img
        v-if="image"
        class="d-block"
        :src="image.src"
        :alt="image.alt">
      <h3 v-if="title">
        {{ title }}
      </h3>
      <p
        v-if="description"
        v-html="$sanitize(description)" />
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'QxEmptyData',
  props: {
    image: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.qx-empty-data {
  padding-bottom: 10px;
  .empty-block {
    margin-bottom: 10%;
  }
  img {
    height: 144px;
    margin: 0 auto 1rem;
  }
  h3 {
    line-height: 24px;
    font-family: $bold-sans-font;
    font-size: 1.2em;
    margin-bottom: 8px;
  }
  p {
    color: $gray-800;
    margin: 0 auto 1rem;
    line-height: 24px;
  }
}
</style>
